<div class="layout-wrapper">
    <div class="layout-content-wrapper">
        <div class="layout-content-wrapper-inside">
            <div app-topbar></div>
            <div class="layout-content">
                <router-outlet></router-outlet>
            </div>
            <div app-footer></div>
        </div>
    </div>
</div>
